import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm flex justify-center items-center z-50"
}
const _hoisted_2 = { class: "bg-[#19202A] border border-transparent rounded-xl w-full max-w-lg p-6 shadow-xl flex flex-col space-y-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold text-white" }, "Uploader un fichier", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-2" }, "Déposez un fichier ici ou", -1)
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-center space-y-2"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "w-full"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "flex flex-col items-center space-y-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/file-icon.svg",
  class: "w-16 h-16 opacity-80",
  alt: "Fichier"
}, null, -1)
const _hoisted_11 = { class: "text-sm text-gray-300" }
const _hoisted_12 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm text-gray-300 mb-1" }, "Catégorie", -1)
const _hoisted_15 = {
  key: 0,
  class: "bg-gray-800 border border-gray-700 rounded px-3 py-2 text-gray-400 flex items-center justify-between"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500 italic" }, "🔒 verrouillée", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Sélectionnez une catégorie", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm text-gray-300 mb-1" }, "Visibilité", -1)
const _hoisted_21 = {
  key: 0,
  class: "bg-gray-800 border border-gray-700 rounded px-3 py-2 text-gray-400 flex items-center justify-between"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500 italic" }, "🔒 verrouillée", -1)
const _hoisted_23 = {
  key: 1,
  class: "flex items-center space-x-6"
}
const _hoisted_24 = { class: "flex items-center space-x-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 text-sm" }, "Public", -1)
const _hoisted_26 = { class: "flex items-center space-x-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 text-sm" }, "Privé (local)", -1)
const _hoisted_28 = {
  key: 1,
  class: "w-full bg-gray-800 rounded-full h-3 mt-2"
}
const _hoisted_29 = { class: "flex justify-end space-x-3" }
const _hoisted_30 = ["disabled"]

import { ref, computed, watch } from "vue";
import api from "@/api";
import useNotyf from "@/composable/useNotyf";
import { currentStation } from "@/state/api/userState";
import { generateQueryParams } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUploaderModal',
  props: {
  show: Boolean,
  source: String,
  lockedVisibility: {
    type: String as () => "public" | "local" | null,
    default: null
  },
  lockedCategory: {
    type: String as () => string | null,
    default: null
  },
},
  emits: ["close", "uploaded"],
  setup(__props, { emit: __emit }) {


const notify = useNotyf();

const props = __props;

const emit = __emit;

const visibility = ref(props.lockedVisibility ?? "local");
const category = ref(props.lockedCategory ?? "");

const file = ref<File | null>(null);
const preview = ref<string | null>(null);

const uploading = ref(false);
const progress = ref(0);

const categories = [
  "logos",
  "images",
  "banners",
  "settings",
  "templates",
  "documents",
  "videos",
  "audios",
  "reports",
  "logs",
  "others",
];

const isImage = computed(() => file.value?.type.startsWith("image/"));
const isVideo = computed(() => file.value?.type.startsWith("video/"));

watch(() => props.lockedVisibility, val => {
  if (val) visibility.value = val;
});

watch(() => props.lockedCategory, val => {
  if (val) category.value = val;
});


const handleFile = (e: any) => {
  const selected = e.target.files[0];
  if (!selected) return;
  file.value = selected;
  generatePreview(selected);
};

const handleDrop = (e: any) => {
  const dropped = e.dataTransfer.files[0];
  if (!dropped) return;
  file.value = dropped;
  generatePreview(dropped);
};

const generatePreview = (f: File) => {
  if (f.type.startsWith("image/") || f.type.startsWith("video/")) {
    preview.value = URL.createObjectURL(f);
  } else {
    preview.value = null;
  }
};

const resetFile = () => {
  file.value = null;
  preview.value = null;
};

const upload = async () => {
  if (!file.value || !category.value) {
    notify.error("Veuillez sélectionner un fichier et une catégorie.");
    return;
  }

  const formData = new FormData();
  formData.append("file", file.value);

  const params = {
    station: currentStation.value?.uuid,
    category: category.value,
    visibility: visibility.value,
  }

  uploading.value = true;
  progress.value = 0;

  await api()
    .files.upload(generateQueryParams(params), formData, {
      onUploadProgress: (event: any) => {
        progress.value = Math.round((event.loaded / event.total) * 100);
      },
    })
    .then((response: any) => {
      notify.success("Fichier envoyé avec succès !");
      emit("uploaded", {
        response: response.data,
        source: props.source
      });
      close();
    })
    .catch((error: any) => {
      console.error(error);
      notify.error("Erreur lors de l'envoi du fichier.");
    })
    .finally(() => {
      uploading.value = false;
      progress.value = 0;
    });
};

const close = () => {
  resetFile();
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "flex justify-between items-center" }, [
            _hoisted_3,
            _createElementVNode("button", {
              onClick: close,
              class: "text-gray-400 hover:text-gray-200 text-xl font-bold"
            }, " × ")
          ]),
          _createElementVNode("div", {
            onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _withModifiers(handleDrop, ["prevent"]),
            class: "flex flex-col items-center justify-center border-2 border-dashed border-gray-600 rounded-lg p-6 text-gray-400 hover:border-accent transition"
          }, [
            _createElementVNode("input", {
              ref: "fileInput",
              type: "file",
              onChange: handleFile,
              class: "hidden"
            }, null, 544),
            (!file.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_4,
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileInput.click())),
                    class: "bg-primary hover:bg-secondary text-white px-4 py-2 rounded"
                  }, " Choisir un fichier ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (isImage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("img", {
                          src: preview.value,
                          alt: "preview",
                          class: "object-contain w-40 h-40 rounded-lg border border-gray-600"
                        }, null, 8, _hoisted_6)
                      ]))
                    : (isVideo.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("video", {
                            controls: "",
                            src: preview.value,
                            class: "rounded-lg w-full max-h-56 border border-gray-600"
                          }, null, 8, _hoisted_8)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("p", _hoisted_11, _toDisplayString(file.value.name), 1)
                        ])),
                  _createElementVNode("button", {
                    onClick: resetFile,
                    class: "text-red-400 text-xs mt-2 hover:text-red-300"
                  }, " Retirer le fichier ")
                ], 64))
          ], 32),
          (file.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (file.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      (props.lockedCategory)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("span", null, _toDisplayString(props.lockedCategory), 1),
                            _hoisted_16
                          ]))
                        : _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 1,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((category).value = $event)),
                            class: "bg-[#0F141B] border border-gray-700 rounded w-full p-2 text-gray-200"
                          }, [
                            _hoisted_17,
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (cat) => {
                              return _createElementVNode("option", {
                                key: cat,
                                value: cat
                              }, _toDisplayString(cat), 9, _hoisted_18)
                            }), 64))
                          ], 512)), [
                            [_vModelSelect, category.value]
                          ])
                    ]))
                  : _createCommentVNode("", true),
                (file.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      (props.lockedVisibility)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("span", null, _toDisplayString(props.lockedVisibility === 'public' ? 'Public' : 'Privé (local)'), 1),
                            _hoisted_22
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("label", _hoisted_24, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                value: "public",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visibility).value = $event)),
                                class: "accent-indigo-600"
                              }, null, 512), [
                                [_vModelRadio, visibility.value]
                              ]),
                              _hoisted_25
                            ]),
                            _createElementVNode("label", _hoisted_26, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                value: "local",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visibility).value = $event)),
                                class: "accent-indigo-600"
                              }, null, 512), [
                                [_vModelRadio, visibility.value]
                              ]),
                              _hoisted_27
                            ])
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (uploading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", {
                  class: "bg-accent h-3 rounded-full transition-all",
                  style: _normalizeStyle({ width: progress.value + '%' })
                }, null, 4)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              onClick: close,
              class: "bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded"
            }, " Annuler "),
            _createElementVNode("button", {
              disabled: !file.value || uploading.value,
              onClick: upload,
              class: "bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white px-4 py-2 rounded"
            }, _toDisplayString(uploading.value ? 'Envoi en cours...' : 'Envoyer'), 9, _hoisted_30)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})